import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AuthService, ReportService } from '@services/index';
import { BreadcrumbComponent } from '@components/index';
import { environment } from 'src/environments/environment';
import { Show } from '@models/report-page.interface';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    /* COMPONENTS */
    BreadcrumbComponent,

    /* MODULES */
    CommonModule,
    MatToolbarModule,
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit, OnDestroy {
  public title$ = this.reportService.title$;
  public show$ = this.reportService.show$;

  public showEnum =  Show;
  
  private subscriptions$: Subscription[] = [];
  


  constructor(
    private reportService: ReportService,
    private authService: AuthService,
  ) { }

  

  ngOnInit(): void {
    console.log(environment); // TODO: remove this after confirming file replacement works on deploy

    const subscription$ = this.reportService.setSessionAuth()
    .subscribe({
      next: response => {
        const sessionAuth = response[0];
        if (!sessionAuth) {

          return;
        }
        this.authService.userId = sessionAuth.user_id;
        this.authService.userEmail = sessionAuth.email;
        this.authService.officeIds = sessionAuth.office_id;
        this.authService.accessObjectIds = sessionAuth.object_id;
        this.authService.accessObjectUniqueName$.next(sessionAuth.access_object_unique_name);
        this.authService.isBetaUser$.next(sessionAuth.is_beta_user)
        this.authService.features$.next(sessionAuth.features)
      },
      error: error => console.error(error)
    });

    this.subscriptions$.push(subscription$);
  }

  ngOnDestroy() { 
    this.subscriptions$.forEach(subscription$ => subscription$.unsubscribe()) 
  }

}
